import { getEmptyMonthlyData } from "./date";

export function computeMonthlyData({ schools, contracts, receipts, expenses, withdraws, currentEducationYear }) {
  let schoolExpenses = [];
  let schoolReceipts = [];
  let schoolWithdraws = [];
  let schoolContracts = [];

  for (let i = 0; i < contracts.length; i++) {
    const contract = contracts[i];
    if (!contract.year || !contract.year.toString()) {
      continue;
    }

    if (contract.year.toString() !== currentEducationYear?.id.toString()) {
      continue;
    }

    const currentSchool = contract?.school?._id.toString();
    if (!currentSchool) {
      continue;
    }

    let schoolEntry = schoolContracts.find((s) => s?.key === currentSchool);

    if (schoolEntry) {
      schoolEntry.amount += parseFloat(contract?.finalAmount);
    } else {
      const schoolName = schools.find((s) => s?.id === currentSchool)?.name || "Bilinmiyor";

      schoolContracts.push({
        key: currentSchool,
        name: schoolName,
        amount: parseFloat(contract.finalAmount),
      });
    }
  }

  // Gelirleri doldur
  for (let i = 0; i < receipts.length; i++) {
    const receipt = receipts[i];
    if (!receipt.contract || !receipt.contract.year.toString()) {
      continue;
    }

    if (receipt.contract.year.toString() !== currentEducationYear?.id.toString()) {
      continue;
    }

    const currentSchool = receipt?.contract?.school?._id.toString();

    if (!currentSchool) {
      continue;
    }
    const monthIndex = parseInt(receipt?.date?.split("-")[1], 10) - 1;

    let schoolEntry = schoolReceipts.find((s) => s?.key === currentSchool);

    if (schoolEntry) {
      schoolEntry.amount += parseFloat(receipt?.amount);
      schoolEntry.schoolMonthlyReceipts[monthIndex].amount += parseFloat(receipt.amount);
    } else {
      const schoolName = schools.find((s) => s?.id === currentSchool)?.name || "Bilinmiyor";
      const schoolMonthlyReceipts = getEmptyMonthlyData();
      schoolMonthlyReceipts[monthIndex].amount = parseFloat(receipt.amount);

      schoolReceipts.push({
        key: currentSchool,
        name: schoolName,
        amount: parseFloat(receipt.amount),
        schoolMonthlyReceipts,
      });
    }
  }

  // Refundlari doldur
  for (let i = 0; i < withdraws.length; i++) {
    const withdraw = withdraws[i];
    if (!withdraw.contract || !withdraw.contract.year.toString()) {
      continue;
    }

    if (withdraw.contract.year.toString() !== currentEducationYear?.id.toString()) {
      continue;
    }

    const currentSchool = withdraw?.contract?.school?._id.toString();

    if (!currentSchool) {
      continue;
    }
    const monthIndex = parseInt(withdraw?.date?.split("-")[1], 10) - 1;

    let schoolEntry = schoolWithdraws.find((s) => s?.key === currentSchool);

    if (schoolEntry) {
      schoolEntry.amount += parseFloat(withdraw?.amount);
      schoolEntry.schoolMonthlyWithdraws[monthIndex].amount += parseFloat(withdraw.amount);
    } else {
      const schoolName = schools.find((s) => s?.id === currentSchool)?.name || "Bilinmiyor";
      const schoolMonthlyWithdraws = getEmptyMonthlyData();
      schoolMonthlyWithdraws[monthIndex].amount = parseFloat(withdraw.amount);

      schoolWithdraws.push({
        key: currentSchool,
        name: schoolName,
        amount: parseFloat(withdraw.amount),
        schoolMonthlyWithdraws,
      });
    }
  }

  for (let i = 0; i < expenses.length; i++) {
    const expense = expenses[i];
    if (!expense.date || !expense.school) {
      continue;
    }

    if (
      expense.date.toString() < currentEducationYear?.yearStartDate ||
      expense.date.toString() > currentEducationYear?.yearEndingDate
    ) {
      continue;
    }

    const currentSchool = expense.school.toString();
    const monthIndex = parseInt(expense.date.split("-")[1], 10) - 1;

    let schoolEntry = schoolExpenses.find((s) => s.key === currentSchool);

    if (schoolEntry) {
      schoolEntry.amount += parseFloat(expense.amount);
      schoolEntry.schoolMonthlyExpenses[monthIndex].amount += parseFloat(expense.amount);
    } else {
      const schoolName = schools.find((s) => s.id === currentSchool)?.name || "Bilinmiyor";
      const schoolMonthlyExpenses = getEmptyMonthlyData();
      schoolMonthlyExpenses[monthIndex].amount = parseFloat(expense.amount);

      schoolExpenses.push({
        key: currentSchool,
        name: schoolName,
        amount: parseFloat(expense.amount),
        schoolMonthlyExpenses,
      });
    }
  }

  const allSchoolInfo = schools.map((school) => {
    const schoolId = school.id.toString();
    const schoolName = school.name || "Bilinmiyor";

    const currentSchoolForContracts = schoolContracts.find((s) => s.key === schoolId);
    let currentSchoolContracts = {
      amount: 0,
    };
    if (currentSchoolForContracts) {
      currentSchoolContracts = {
        amount: currentSchoolForContracts.amount,
      };
    }

    const currentSchoolForReceipts = schoolReceipts.find((s) => s.key === schoolId);
    let currentSchoolReceipts = {
      amount: 0,
      schoolMonthlyReceipts: getEmptyMonthlyData(),
    };
    if (currentSchoolForReceipts) {
      currentSchoolReceipts = {
        amount: currentSchoolForReceipts.amount,
        months: currentSchoolForReceipts.schoolMonthlyReceipts,
      };
    }

    const currentSchoolForWithdraws = schoolWithdraws.find((s) => s.key === schoolId);
    let currentSchoolWithdraws = {
      amount: 0,
      months: getEmptyMonthlyData(),
    };
    if (currentSchoolForWithdraws) {
      currentSchoolWithdraws = {
        amount: currentSchoolForWithdraws.amount,
        months: currentSchoolForWithdraws.schoolMonthlyWithdraws,
      };
    }

    const currentSchoolForExpenses = schoolExpenses.find((s) => s.key === schoolId);
    let currentSchoolExpenses = {
      amount: 0,
      months: getEmptyMonthlyData(),
    };
    if (currentSchoolForExpenses) {
      currentSchoolExpenses = {
        amount: currentSchoolForExpenses.amount,
        months: currentSchoolForExpenses.schoolMonthlyExpenses,
      };
    }

    return {
      id: schoolId,
      name: schoolName,
      receipts: currentSchoolReceipts || { amount: 0, months: getEmptyMonthlyData() },
      withdraws: currentSchoolWithdraws || { amount: 0, months: getEmptyMonthlyData() },
      expenses: currentSchoolExpenses || { amount: 0, months: getEmptyMonthlyData() },
      contracts: currentSchoolContracts || { amount: 0 },
    };
  });

  return {
    schools: allSchoolInfo,
    totalContractsAmount: schoolContracts.reduce((acc, contract) => acc + contract.amount, 0),
    totalReceiptsAmount: allSchoolInfo.reduce((acc, school) => acc + school.receipts.amount, 0),
    totalWithdrawsAmount: allSchoolInfo.reduce((acc, school) => acc + school.withdraws.amount, 0),
    totalExpensesAmount: allSchoolInfo.reduce((acc, school) => acc + school.expenses.amount, 0),
  };
}
